import Component from '../abstracts/Component';

export default class WallComponent extends Component {


  get SELECTORS() {
    return {
      wall: '.c-wall',
      element: '.wall-item',
      waypoint: '.js-wall-panel-waypoint',
      expanderBtn: ''
    };
  }


  constructor() {
    super();
    this.main = document.querySelectorAll(this.SELECTORS.wall);
    this.Opened = false;
    this.panel = $('.js-custom-panel');
    this.trigger = $('.panel-trigger');
  }


  importLibrary() {
    this.moduleLoader.loadMasonry(
      (module) => {
        console.log('Masonry initialised');
        const Masonry = module.default;

        this.main.forEach( grid => {
          this.buildLayout(grid);

          const msnry = new Masonry(
          grid ,{
            itemSelector: '.wall-item',
            horizontalOrder: true,
            percentPosition: true
          });
        })
      },
      (error) => {
        console.log("failed to load Masonry ", error.stack);
      }
    )
  }


  buildLayout(grid) {
    let rectH = grid.childNodes[1].getBoundingClientRect().height;
    let rectW = grid.childNodes[1].getBoundingClientRect().width;
    let ratio = 3.648424138773;
    let bigmargin = rectH - rectW;
    let smallmargin = bigmargin / ratio;
    let layoutType = grid.dataset.wall;

    switch(layoutType) {

      case 'layout_A':
        grid.childNodes[1].style.marginTop = smallmargin + 'px';
        grid.childNodes[3].style.marginTop = bigmargin + 'px';
        grid.classList.add('is-ready');
        break;

      case 'layout_B':
        grid.childNodes[1].style.marginTop = smallmargin + 'px';
        grid.childNodes[3].style.marginTop = bigmargin + 'px';
        grid.classList.add('is-ready');
        break;

      case 'layout_C':
        grid.childNodes[1].style.marginTop = smallmargin + 'px';
        grid.childNodes[3].style.marginTop = smallmargin + 'px';
        grid.classList.add('is-ready');
        break;
    }
  }

  onCreatePanel() {
    return new Promise((resolve, reject) => {
      try {

      let wallEl = $(this.main).find(this.SELECTORS.element);
      let index = '';

      $('.cta-container > button').addClass('js-panel-trigger')

      for(let item of wallEl) {
        if(item.classList.contains('js-wall-panel-waypoint')) {
          const siblings = $(item).nextAll();
          siblings.wrapAll(`<div class="js-custom-panel wall-item-panel" style="height:0; overflow:hidden;"> </div>`);
          index = 0
        }
      }
        resolve(true);
      } catch (e) {
        reject(e)
      }
    });
  }



  render() {
    if (document.querySelectorAll( this.SELECTORS.wall) && this.$matchMedia('sm', null)) {
      this.onCreatePanel().then(res => {
        CustomPanel();
      }).catch(err => {
        console.log('cannot create panel')
      });
    }

    if (document.querySelectorAll( this.SELECTORS.wall) && this.$matchMedia(null, 'sm')) this.importLibrary();
  }
}
